import type { ReactNode } from 'react';

export const symbol_nest_detect: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M369.9-80Q316-80 278-118.07q-38-38.07-38-91.93v-610q0-24.75 17.63-42.38Q275.25-880 300-880h140q24.75 0 42.38 17.62Q500-844.75 500-820v610q0 53.86-38.1 91.93Q423.8-80 369.9-80ZM300-320q20-12 37.5-16t32.5-4q15 0 32.5 4t37.5 16v-500H300v500Zm69.88 180q29.12 0 49.62-20.38 20.5-20.38 20.5-49.5t-20.38-49.62q-20.38-20.5-49.5-20.5t-49.62 20.38q-20.5 20.38-20.5 49.5t20.38 49.62q20.38 20.5 49.5 20.5ZM660-240q-24.75 0-42.37-17.63Q600-275.25 600-300v-360q0-24.75 17.63-42.38Q635.25-720 660-720h80q24.75 0 42.38 17.62Q800-684.75 800-660v360q0 24.75-17.62 42.37Q764.75-240 740-240h-80Zm0-60h80v-360h-80v360ZM300-820h140-140Zm360 520h80-80Z"
		/>
	</svg>
);
